// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup_WuqWh {
  font: normal 400 var( --size-bodyMedium )/1.2 Inter;
  color: var( --color-base800 );
  border: 1px solid var( --color-base100 );
  min-width: 200px;
  box-shadow: 0 8px 16px var( --color-shadowBase ),0 0px 1px var( --color-shadowBase );
  margin-top: 4px;
  max-height: 600px;
  border-radius: 4px;
  background-color: var( --color-white );
}
.popup_WuqWh > .popupItem_itOrI {
  font: normal normal 13px/20px Inter;
  color: var( --color-base700 );
  width: 100%;
  padding: var( --size-padMedium ) var( --size-padLarge );
  display: inline-grid;
  overflow: hidden;
  min-width: 160px;
  text-align: left;
  min-height: 40px;
  white-space: nowrap;
  text-overflow: clip;
}
.popup_WuqWh > .popupItem_itOrI:hover {
  background-color: var( --color-base050 );
}
.popup_WuqWh > .popupItem_itOrI:focus {
  background-color: var( --color-base050 );
}
.popup_WuqWh > .popupItem_itOrI:focus-within {
  background-color: var( --color-base050 );
}
.popup_WuqWh > .popupItem_itOrI:active:focus {
  color: var( --color-brand500 );
}
.popup_WuqWh > .popupItem_itOrI[disabled] {
  color: var( --color-base300 );
}
.popup_WuqWh > .popupDivider_j6zVe {
  height: 1px;
  background-color: var( --color-base100 );
}
.popup_WuqWh> .popupHeader_uxDwc {
  font: small-caps bold 12px/18px Inter;
  color: var( --color-base500 );
  padding: var( --size-padMedium ) var( --size-padMedium ) var( --size-padSmall );
  text-transform: uppercase;
}
.popup_WuqWh.popup-mainScreenMode_lxS51 {
  padding: var( --size-padSmall );
  margin-top: var( --size-padSmall );
}
.popup_WuqWh.popup-mainScreenMode_lxS51 > .popupItem_itOrI {
  color: var( --color-base300 );
  font-size: var( --size-header4 );
  min-width: 0px;
  border-radius: var( --size-small );
}
.popup_WuqWh.popup-mainScreenMode_lxS51 > .popupItem_itOrI:hover {
  color: var( --color-brand500 );
  background-color: var( --color-brand100 );
}
.popup_WuqWh.popup-mainScreenMode_lxS51 > .popupItem_itOrI:active:focus {
  color: var( --color-brand500 );
}
.popup_WuqWh.popup-dashboardCardEditorPopup_foXmx {
  padding: var( --size-padMedium );
}
.popup_WuqWh.popup-mobileSuggestions_uXoDu {
  border-top-width: 0px;
  border-top-color: transparent;
  border-left-width: 0px;
  border-left-color: transparent;
  border-right-width: 0px;
  border-right-color: transparent;
  border-bottom-width: 0px;
  border-bottom-color: transparent;
}
.popup_WuqWh.popup-mobileSuggestions_uXoDu > .popupItem_itOrI {
  width: 100vw;
  padding: var( --size-padLarge );
  border-bottom: 1px solid var( --color-base100 );
}
.popup_WuqWh.popup-mobileSuggestions_uXoDu > .popupItem_itOrI:hover {
  background-color: var( --color-base100 );
}
.popup_WuqWh.popup-mobileSuggestions_uXoDu > .popupItem_itOrI:focus {
  background-color: var( --color-base100 );
}
.popup_WuqWh.popup-mobileSuggestions_uXoDu > .popupItem_itOrI:focus-within {
  background-color: var( --color-base100 );
}
.popup_WuqWh.popup-suggestions_T0KT4 {
  border-top-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 0px;
}
.popup_WuqWh.popup-suggestions_T0KT4 > .popupItem_itOrI {
  width: 100%;
}
.popup_WuqWh.popup-suggestions_T0KT4 > .popupItem_itOrI:hover {
  background-color: var( --color-base100 );
}
.popup_WuqWh.popup-suggestions_T0KT4 > .popupItem_itOrI:focus {
  background-color: var( --color-base100 );
}
.popup_WuqWh.popup-suggestions_T0KT4 > .popupItem_itOrI:focus-within {
  background-color: var( --color-base100 );
}
.popup_WuqWh.popup-layoutActionBar_meZDt {
  padding-top: var( --size-padMedium );
  padding-bottom: var( --size-padMedium );
}
.popup_WuqWh.popup-layoutActionBar_meZDt > .popupItem_itOrI {
  width: 280px;
  height: 40px;
}
.popup_WuqWh.popup-layoutActionBar_meZDt > .popupDivider_j6zVe {
  margin-top: var( --size-medium );
  margin-bottom: var( --size-medium );
}
.popup_WuqWh.popup-layoutActionBar_meZDt> .popupHeader_uxDwc {
  font: 600 12px/18px Inter;
  color: var( --color-base600 );
}
.popup_WuqWh.popup-attributeSelector_zao_l {
  max-height: 500px;
}
.popup_WuqWh.popup-attributeSelector_zao_l > .popupItem_itOrI {
  font: normal 13px/20px Inter;
  color: #495a6e;
}
.popup_WuqWh.popup-attributeSelector_zao_l> .popupHeader_uxDwc {
  background-color: var( --color-white );
}
.popup_WuqWh.popup-scheduleSelector_VjM8_ > .popupItem_itOrI {
  width: auto;
}
.popup_WuqWh.popup-conditionSelector_PnKGi {
  max-height: 600px;
}
.popup_WuqWh.popup-conditionSelector_PnKGi > .popupItem_itOrI {
  font: normal 13px/20px Inter;
  color: #495a6e;
}
.popup_WuqWh.popup-conditionSelector_PnKGi > .popupItem_itOrI > :nth-child(2) {
  margin-right: 24px;
}
.popup_WuqWh.popup-actionBar_AdCXs {
  min-width: 250px;
}
.popup_WuqWh.popup-logicConditionOperator_dd_Dp > .popupItem_itOrI > :nth-child(2) {
  margin-right: 24px;
}
.popup_WuqWh.popup-valueSourcePill_AX360 {
  min-width: auto;
}
.popup_WuqWh.popup-arrayMore_HjkdY {
  min-width: auto;
  min-height: auto;
}
.popup_WuqWh.popup-arrayMore_HjkdY > .popupItem_itOrI {
  width: auto;
  height: auto;
  min-width: auto;
  min-height: auto;
}
.popup_WuqWh.popup-attributeEditor_upKRZ {
  margin: 0px;
}
.popup_WuqWh.popup-attributeStringArrayEditor_GZ8FZ {
  max-width: 400px;
}
.popup_WuqWh.popup-setIcon_ZNJHW {
  border: 1px solid var( --color-base400 );
  padding: 20px;
}`, "",{"version":3,"sources":["webpack://./src/theme/Popup.css"],"names":[],"mappings":"AAAA;EACE,mDAAmD;EACnD,6BAA6B;EAC7B,wCAAwC;EACxC,gBAAgB;EAChB,oFAAoF;EACpF,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,mCAAmC;EACnC,6BAA6B;EAC7B,WAAW;EACX,uDAAuD;EACvD,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,8BAA8B;AAChC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,wCAAwC;AAC1C;AACA;EACE,qCAAqC;EACrC,6BAA6B;EAC7B,+EAA+E;EAC/E,yBAAyB;AAC3B;AACA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;AACA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,cAAc;EACd,kCAAkC;AACpC;AACA;EACE,8BAA8B;EAC9B,yCAAyC;AAC3C;AACA;EACE,8BAA8B;AAChC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;EACvB,+BAA+B;EAC/B,wBAAwB;EACxB,gCAAgC;AAClC;AACA;EACE,YAAY;EACZ,+BAA+B;EAC/B,+CAA+C;AACjD;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,WAAW;AACb;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,oCAAoC;EACpC,uCAAuC;AACzC;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,gCAAgC;EAChC,mCAAmC;AACrC;AACA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,4BAA4B;EAC5B,cAAc;AAChB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;AACA;EACE,4BAA4B;EAC5B,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,wCAAwC;EACxC,aAAa;AACf","sourcesContent":[".popup {\n  font: normal 400 var( --size-bodyMedium )/1.2 Inter;\n  color: var( --color-base800 );\n  border: 1px solid var( --color-base100 );\n  min-width: 200px;\n  box-shadow: 0 8px 16px var( --color-shadowBase ),0 0px 1px var( --color-shadowBase );\n  margin-top: 4px;\n  max-height: 600px;\n  border-radius: 4px;\n  background-color: var( --color-white );\n}\n.popup > .popupItem {\n  font: normal normal 13px/20px Inter;\n  color: var( --color-base700 );\n  width: 100%;\n  padding: var( --size-padMedium ) var( --size-padLarge );\n  display: inline-grid;\n  overflow: hidden;\n  min-width: 160px;\n  text-align: left;\n  min-height: 40px;\n  white-space: nowrap;\n  text-overflow: clip;\n}\n.popup > .popupItem:hover {\n  background-color: var( --color-base050 );\n}\n.popup > .popupItem:focus {\n  background-color: var( --color-base050 );\n}\n.popup > .popupItem:focus-within {\n  background-color: var( --color-base050 );\n}\n.popup > .popupItem:active:focus {\n  color: var( --color-brand500 );\n}\n.popup > .popupItem[disabled] {\n  color: var( --color-base300 );\n}\n.popup > .popupDivider {\n  height: 1px;\n  background-color: var( --color-base100 );\n}\n.popup> .popupHeader {\n  font: small-caps bold 12px/18px Inter;\n  color: var( --color-base500 );\n  padding: var( --size-padMedium ) var( --size-padMedium ) var( --size-padSmall );\n  text-transform: uppercase;\n}\n.popup.popup-mainScreenMode {\n  padding: var( --size-padSmall );\n  margin-top: var( --size-padSmall );\n}\n.popup.popup-mainScreenMode > .popupItem {\n  color: var( --color-base300 );\n  font-size: var( --size-header4 );\n  min-width: 0px;\n  border-radius: var( --size-small );\n}\n.popup.popup-mainScreenMode > .popupItem:hover {\n  color: var( --color-brand500 );\n  background-color: var( --color-brand100 );\n}\n.popup.popup-mainScreenMode > .popupItem:active:focus {\n  color: var( --color-brand500 );\n}\n.popup.popup-dashboardCardEditorPopup {\n  padding: var( --size-padMedium );\n}\n.popup.popup-mobileSuggestions {\n  border-top-width: 0px;\n  border-top-color: transparent;\n  border-left-width: 0px;\n  border-left-color: transparent;\n  border-right-width: 0px;\n  border-right-color: transparent;\n  border-bottom-width: 0px;\n  border-bottom-color: transparent;\n}\n.popup.popup-mobileSuggestions > .popupItem {\n  width: 100vw;\n  padding: var( --size-padLarge );\n  border-bottom: 1px solid var( --color-base100 );\n}\n.popup.popup-mobileSuggestions > .popupItem:hover {\n  background-color: var( --color-base100 );\n}\n.popup.popup-mobileSuggestions > .popupItem:focus {\n  background-color: var( --color-base100 );\n}\n.popup.popup-mobileSuggestions > .popupItem:focus-within {\n  background-color: var( --color-base100 );\n}\n.popup.popup-suggestions {\n  border-top-width: 0px;\n  border-left-width: 0px;\n  border-right-width: 0px;\n  border-bottom-width: 0px;\n}\n.popup.popup-suggestions > .popupItem {\n  width: 100%;\n}\n.popup.popup-suggestions > .popupItem:hover {\n  background-color: var( --color-base100 );\n}\n.popup.popup-suggestions > .popupItem:focus {\n  background-color: var( --color-base100 );\n}\n.popup.popup-suggestions > .popupItem:focus-within {\n  background-color: var( --color-base100 );\n}\n.popup.popup-layoutActionBar {\n  padding-top: var( --size-padMedium );\n  padding-bottom: var( --size-padMedium );\n}\n.popup.popup-layoutActionBar > .popupItem {\n  width: 280px;\n  height: 40px;\n}\n.popup.popup-layoutActionBar > .popupDivider {\n  margin-top: var( --size-medium );\n  margin-bottom: var( --size-medium );\n}\n.popup.popup-layoutActionBar> .popupHeader {\n  font: 600 12px/18px Inter;\n  color: var( --color-base600 );\n}\n.popup.popup-attributeSelector {\n  max-height: 500px;\n}\n.popup.popup-attributeSelector > .popupItem {\n  font: normal 13px/20px Inter;\n  color: #495a6e;\n}\n.popup.popup-attributeSelector> .popupHeader {\n  background-color: var( --color-white );\n}\n.popup.popup-scheduleSelector > .popupItem {\n  width: auto;\n}\n.popup.popup-conditionSelector {\n  max-height: 600px;\n}\n.popup.popup-conditionSelector > .popupItem {\n  font: normal 13px/20px Inter;\n  color: #495a6e;\n}\n.popup.popup-conditionSelector > .popupItem > :nth-child(2) {\n  margin-right: 24px;\n}\n.popup.popup-actionBar {\n  min-width: 250px;\n}\n.popup.popup-logicConditionOperator > .popupItem > :nth-child(2) {\n  margin-right: 24px;\n}\n.popup.popup-valueSourcePill {\n  min-width: auto;\n}\n.popup.popup-arrayMore {\n  min-width: auto;\n  min-height: auto;\n}\n.popup.popup-arrayMore > .popupItem {\n  width: auto;\n  height: auto;\n  min-width: auto;\n  min-height: auto;\n}\n.popup.popup-attributeEditor {\n  margin: 0px;\n}\n.popup.popup-attributeStringArrayEditor {\n  max-width: 400px;\n}\n.popup.popup-setIcon {\n  border: 1px solid var( --color-base400 );\n  padding: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popup": `popup_WuqWh`,
	"popupItem": `popupItem_itOrI`,
	"popupDivider": `popupDivider_j6zVe`,
	"popupHeader": `popupHeader_uxDwc`,
	"popup-mainScreenMode": `popup-mainScreenMode_lxS51`,
	"popup-dashboardCardEditorPopup": `popup-dashboardCardEditorPopup_foXmx`,
	"popup-mobileSuggestions": `popup-mobileSuggestions_uXoDu`,
	"popup-suggestions": `popup-suggestions_T0KT4`,
	"popup-layoutActionBar": `popup-layoutActionBar_meZDt`,
	"popup-attributeSelector": `popup-attributeSelector_zao_l`,
	"popup-scheduleSelector": `popup-scheduleSelector_VjM8_`,
	"popup-conditionSelector": `popup-conditionSelector_PnKGi`,
	"popup-actionBar": `popup-actionBar_AdCXs`,
	"popup-logicConditionOperator": `popup-logicConditionOperator_dd_Dp`,
	"popup-valueSourcePill": `popup-valueSourcePill_AX360`,
	"popup-arrayMore": `popup-arrayMore_HjkdY`,
	"popup-attributeEditor": `popup-attributeEditor_upKRZ`,
	"popup-attributeStringArrayEditor": `popup-attributeStringArrayEditor_GZ8FZ`,
	"popup-setIcon": `popup-setIcon_ZNJHW`
};
export default ___CSS_LOADER_EXPORT___;
